/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $BillCreate = {
    properties: {
        billingCycleId: {
            type: 'string',
            isRequired: true,
            format: 'uuid',
        },
        pastDueAmount: {
            type: 'number',
            isRequired: true,
            format: 'double',
        },
        dueAmount: {
            type: 'number',
            isRequired: true,
            format: 'double',
        },
        meterUsages: {
            type: 'MeterUsages',
        },
        attachedFilename: {
            type: 'string',
            isNullable: true,
        },
        attachedFileEncodedData: {
            type: 'string',
            isNullable: true,
        },
    },
};